export default "__VITE_ASSET__9629203c__"